import React from 'react';

/** SAM-730 — padlock shown next to private events (inline SVG, inherits currentColor). */
export const PrivateLockIcon: React.FC<{ label: string; size?: number; style?: React.CSSProperties }> = ({
  label, size = 16, style,
}) => (
  <svg
    role="img"
    aria-label={label}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ flexShrink: 0, ...style }}
  >
    <title>{label}</title>
    <rect x="4" y="11" width="16" height="10" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </svg>
);
